interface SentryWindow extends Window {
  Sentry?: {
    captureException: (error: Error, context?: Record<string, unknown>) => void;
  };
}

declare const window: SentryWindow;

/**
 * Sets up global error handlers for unhandled JavaScript errors and promise rejections.
 * Should be called once during app initialization.
 */
export const setupGlobalErrorHandlers = (): void => {
  // Global error handler for unhandled JavaScript errors
  window.addEventListener('error', (event) => {
    if (window.Sentry && event.error instanceof Error) {
      window.Sentry.captureException(event.error);
    }
  });

  // Global handler for unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (window.Sentry) {
      const error = event.reason instanceof Error 
        ? event.reason 
        : new Error(String(event.reason));
      window.Sentry.captureException(error);
    }
    event.preventDefault();
  });
};
